import react from 'react';
import { apiURL } from '../utils/constants';
import { message } from "antd"
import { Fonts } from "../utils/constants";

function GetCP(cp: string) : any {
    return new Promise((resolve, reject) => {
        fetch(apiURL +`/PostalCode?postalCode=${cp}`)
        .then(response => response.json())
        .then(response => resolve(response))
        .catch(error => {
            reject(error)
            message.error({ content: 'Error al consultar el código postal', style: { fontFamily: Fonts.sspRegular } });
        })
    })
}

export default GetCP